<template>
  <section id="main-content">
    <header class="general-header">
      <h1>Relatório de inscrição</h1>
      <h2 v-if="currentSubsModel == 'onhb'">Criando novo processo de pagamento</h2>
      <h2 v-else>Criando nova inscrição na modalidade '{{currentModality == 'pre_individual' ? 'individual' : currentModality == 'pre_zapzap'? 'zap-zap' : 'domicílio'}}'</h2>
    </header>
    <div id="report">
      <div id="your-data" class="report-container">
        <h3>Responsável pela inscrição</h3>
        <p class="mono">
          {{currentUser.name}} {{currentUser.surname}} /
          <a
            :href="`mailto:${currentUser.email}`"
          >{{currentUser.email}}</a>
        </p>
      </div>
      
      <template v-if="currentModality=='student'">
        <div class="report-container">
          <h3>Inscrição de uma equipe</h3>
          <p>
            Você está inscrevendo uma equipe da
            <span
              class="mono"
            >{{chosenSchoolData.NewSuiInstitution.name}},</span>
            escola {{schoolType(chosenSchoolData.NewSuiInstitution.type)}}
            de registro
            <span
              class="mono"
            >{{chosenSchoolData.NewSuiInstitution.id}},</span>
            sediada em {{chosenSchoolData.NewSuiInstitution.city}},&nbsp;{{chosenSchoolData.NewSuiInstitution.state}}.
          </p>
          <p>Após gerar o pagamento, você deverá convidar outros(as) dois(duas) colegas para participar da equipe, além do(a) professor(a) responsável.</p>
          <p>A equipe só estará apta para participar uma vez que todos(as) participantes tenham contas válidas para acessar o sistema da Olimpíada de Matemática e uma vez que o pagamento do boleto tenha sido detectado.</p>
        </div>
      </template>
      <template v-if="currentModality=='teacher'">
        <div class="report-container">
          <h3>Inscrição de {{numberOfTeams}} equipe{{numberOfTeams != 1 ? 's' : ''}}</h3>
          <p>
            Você está inscrevendo {{numberOfTeams}} equipe{{numberOfTeams != 1 ? 's' : ''}} da
            <span
              class="mono"
            >{{chosenSchoolData.NewSuiInstitution.name}},</span>
            escola {{schoolType(chosenSchoolData.NewSuiInstitution.type)}}
            de registro
            <span
              class="mono"
            >{{chosenSchoolData.NewSuiInstitution.id}},</span>
            sediada em {{chosenSchoolData.NewSuiInstitution.city}},&nbsp;{{chosenSchoolData.NewSuiInstitution.state}}.
          </p>
          <template v-if="numberOfTeams != 1">
            <p>Após gerar o pagamento, você deverá convidar, por meio deste mesmo site, os(as) três estudantes destas equipes.</p>
            <p>
              As equipes só estarão aptas a participar uma vez que todos(as) alunos(as) participantes tenham criado e validado contas para acessar o sistema da Olimpíada de Matemática
              <strong>e</strong> uma vez que o pagamento do boleto tenha sido detectado.
            </p>
          </template>
          <template v-else>
            <p>Após gerar o pagamento, você deverá convidar, por meio deste mesmo site, os(as) três estudantes da equipe.</p>
            <p>
              A equipe só estará apta a participar uma vez que todos(as) alunos(as) participantes tenham criado e validado contas para acessar o sistema da Olimpíada de Matemática
              <strong>e</strong> uma vez que o pagamento do boleto tenha sido detectado.
            </p>
          </template>
        </div>
      </template>
      <template v-if="currentModality=='wildcard'">
        <div class="report-container" id="wildcard-report">
          <h3>Inscrição de {{numberOfTeams}} equipe{{numberOfTeams != 1 ? 's' : ''}} com {{teacherList.length}} professor{{teacherList.length != 1 ? 'es(as) responsáveis' : '(a) responsável'}}</h3>
          <p id="invited-teachers-summary">
            {{numberOfTeams != 1 ? 'As equipes estarão associadas' : 'A equipe estará associada'}}
            à
            <span
              class="mono"
            >{{chosenSchoolData.NewSuiInstitution.name}},</span>
            escola {{schoolType(chosenSchoolData.NewSuiInstitution.type)}}
            de registro
            <span
              class="mono"
            >{{chosenSchoolData.NewSuiInstitution.id}},</span>
            sediada em {{chosenSchoolData.NewSuiInstitution.city}},&nbsp;{{chosenSchoolData.NewSuiInstitution.state}}.
          </p>
          <button
            class="btn-action"
            @click="backToTeachers"
          >Mudar composição {{teacherList.length != 1 ? 'das equipes' : 'da equipe'}}</button>
          <ul id="invited-teachers-list">
            <li v-for="(teacher, i) in teacherList" :key="`teacher-${i}`">
              <h4>{{teacher.teams}} equipe{{teacher.teams != 1 ? 's' : ''}}</h4>
              <p>
                Supervisionada{{teacher.teams != 1 ? 's' : ''}} por {{teacher.name}} {{teacher.surname}} (&#8203;
                <a
                  :href="`mailto:${teacher.email}`"
                >{{teacher.email}}</a>)
              </p>
            </li>
          </ul>
        </div>
      </template>
    </div>

    <div class="white-box" id="billet" v-if="currentSubsModel == 'onhb'">
      <!-- <h2>Gerar boleto</h2> -->
      <div class="small-fields">
        <h3>Responsável pelo boleto</h3>
        <div class="single-field-container">
          <label class="generic-label" for="full-name">Nome completo</label>
          <input type="text" class="generic-input" id="full-name" v-model="payName"/>
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="cpf-cnpj">CPF / CNPJ</label>
          <input type="text" class="generic-input" id="cpf-cnpj" v-model="payCnpjCpf"/>
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="cep">CEP</label>
          <input type="text" class="generic-input" id="cep" v-model="payPostalCode" maxlength="9" />
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="state">Estado (UF)</label>
          <select class="generic-input" id="state" v-model="payState">
            <option v-for="state in stateList" v-bind:value="state.id" v-bind:key="state.id">
              {{ state.name }}
            </option>
          </select>
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="city">Cidade</label>
          <input type="text" class="generic-input" id="city" v-model="payCity" />
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="address">Logradouro (rua/avenida/etc)</label>
          <input type="text" class="generic-input" id="address" v-model="payAddressLine" />
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="number">Número</label>
          <input type="text" class="generic-input" id="number" v-model="payNumber" />
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="extra">Complemento <small>(opcional)</small></label>
          <input type="text" class="generic-input" id="extra" v-model="payExtra" />
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="neighbor">Bairro</label>
          <input type="text" class="generic-input" id="neighbor" v-model="payNeighbor" />
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="phone">Telefone de contato (com DDD)</label>
          <input type="text" class="generic-input" id="phone" v-model="payPhone" />
        </div>
        <div class="single-field-container">
          <label class="generic-label" for="email">Email de contato </label>
          <input type="text" class="generic-input" id="email" v-model="payEmail" />
        </div>

      </div>
      <div id="hacky-divider"></div>
      <div id="billet-generator">
        <div id="summary">
          <h4>Inscrição de {{numberOfTeams}} equipe{{numberOfTeams != 1 ? 's' : ''}}</h4>
          <p>Valor do boleto: R$&#8201;{{registrationCost()}},00</p>
          <p>O boleto deve sair com vencimento para dia <strong>{{paymentDue | dateToBr}}</strong>*, págavel em qualquer banco.</p><p><small>* Este vencimento pode ser diferente uma vez que o boleto seja gerado, por isto, verifique sempre o vencimento no boleto.</small></p>
        </div>
        <button class="btn-main-action" @click="dispatchBillet" :class="{'btn-loading': amILoading}"  :disabled="amILoading">Confirmar e gerar boleto</button>
      </div>
    </div>
    <div class="white-box" id="billet" v-else>
      <div class="small-fields"> <p>Se os dados acima estão certos, avance para a próxima etapa para dar início ao seu processo de inscrição e preencher os dados de todos os participantes.</p></div>
      <div id="hacky-divider"></div>
      <button class="btn-main-action" @click="dispatchBillet" :class="{'btn-loading': amILoading}"  :disabled="amILoading">Avançar </button>
    </div>
  </section>
</template>

<script>
  import {mapGetters} from "vuex";
  import stateList from "../../assets/state-list";
import store from "../../store";
import router from "../../router";

export default {
  name: "StepRegistrationReport",
  data: function() {
    return {
      "stateList":  stateList
    }
  },
  created: function () {
    if (store.state.Subscription.NewSuiApplication.modality == 'teacher') {
      store.commit("ADD_USER_DATA_TO_TEACHER_LIST");
    }
  },
  computed: {
    ...mapGetters([
      "currentModality",
      "currentUser",
      "chosenSchoolData",
      "teacherList",
      "amILoading",
      "registrationCost",
      "numberOfTeams",
      "paymentDue",
      "currentSubsModel"
    ]),
    payName:        { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_name;},             set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_name", value});} },
    payCnpjCpf:     { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_document;},         set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_document", value});} },
    payAddressLine: { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address;},          set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address", value});} },
    payNumber:      { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_number;},   set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_number", value});} },
    payNeighbor:    { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_neighbor;}, set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_neighbor", value});} },
    payExtra:       { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_2;},        set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_2", value});} },
    payState:       { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_state;},    set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_state", value});} },
    payCity:        { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_city;},     set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_city", value});} },
    payPostalCode:  { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_cep;},      set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_cep", value});} },
    payPhone:       { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_telephone;},        set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_telephone", value});} },
    payEmail:       { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_email;},            set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_email", value});} },
    accumulatedTeams: function() {
      let accum = [];
      let count = 0;
      this.teacherList.forEach(t => {
        let previous = count;
        count += parseInt(t.teams);
        accum.push([previous + 1, count]);
      });
      return accum;
    },
  },
  methods: {
    dispatchBillet: function() {
      store.dispatch("createBillet")
              .then(function() {
                store.commit("GOTO_STEP_TEAM_COMPOSITION");
                router.push({
                  name: "nothingButFlowers",
                  params: {
                    subsSlug: store.state.Subscription.subscription_slug,
                    step: "team-composition",
                    process: store.state.Interface.justSavedApplicationId
                  }
                });
              })
              .catch(function () {});
    },
    backToTeachers: function() {
      store.commit("BACK_TO_TEACHERS");
      router.push({
        name: "nothingButFlowers",
        params: {
          subsSlug: store.state.Subscription.subscription_slug,
          step: "teachers"
        }
      });
    },
    schoolType: function(type) {
      let types = { public: "pública", private: "privada", public_with_selection: "pública COM PROCESSO SELETIVO"};
      if (type in types) {
        return types[type];
      }
      return type;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/_mixins.scss";
@import "@/assets/static/css/_definitions.scss";

.general-header {
  padding-bottom: pad(2);
}

#report {
  @extend .white-box;
  background: tertiary-color(0);
}

.report-container {
  h2 {
    margin-bottom: pad(0);
  }

  margin: 0 auto;
  & + .report-container {
    margin-top: pad(1);
  }

  p {
    max-width: 72ch;
  }
}

#billet {
  margin-top: pad(2);

  display: grid;
  grid-column-gap: pad(0);
  grid-row-gap: pad(0);
  grid-template-columns: 4fr 0fr 3fr;

  @include respond-below(xs) {
    grid-template-columns: 1fr;
  }

  h2 {
    grid-column: 1 / -1;
  }
  .small-fields {
    grid-column: 1;
  }
  #billet-generator {
    @include respond-above(xs) {
      grid-column: 3;
    }

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .btn-main-action {
      @include respond-above(xs) {
        margin-left: auto;
      }
    }
  }
}

#hacky-divider {
  grid-column: 2 / 3;
  border-right: 1px solid grays(8);

  @include respond-below(xs) {
    display: none;
  }
}

#summary {
  margin-bottom: pad(0);
  padding: pad(-1);
  background: secondary-color();
  p {
    color: grays(3);
  }
  h4 {
    @include faux-caps;
    font-weight: bold;
    padding-bottom: pad(-3);
  }
}

#invited-teachers-summary {
  margin-bottom: pad(0);
}

#invited-teachers-list {
  margin-top: pad(0);

  display: grid;
  grid-template-columns: 1fr;

  li {
    padding: pad(-1) 0;
    border-top: 1px solid tertiary-color(1);

    display: grid;
    grid-template-columns: 1fr max-content;
    grid-row-gap: pad(-3);

    @include respond-below(xs) {
      grid-template-columns: 1fr;
      grid-row-gap: pad(-2);
    }

    h4 {
      grid-column: 1 / -1;
    }

    p {
      @include fs(-1);
    }

    &:last-child {
      border-bottom: 1px solid tertiary-color(1);
    }
  }
}
</style>
